import { render, staticRenderFns } from "./Question_A.vue?vue&type=template&id=3a3a71bf&scoped=true&"
import script from "./Question_A.vue?vue&type=script&lang=js&"
export * from "./Question_A.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3a71bf",
  null
  
)

export default component.exports